
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ErrorModalComponent } from '../../../components/tools/modals/error-modal/error-modal.component';
import { SucursalesService } from '../../../services/sucursales.service';
import { HelpersService } from '../../../services/tools/helpers.service';

declare var $;

@Component({
  selector: 'app-sucursales-modal',
  templateUrl: './sucursales-modal.component.html',
  styleUrls: ['./sucursales-modal.component.scss']
})
export class SucursalesModalComponent implements OnInit {
  
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
 
  selected: any = {};
  errors: any = {};
  processing: boolean = false;
  isUpdate: boolean = false;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor(
      private sucursalesService: SucursalesService,
      private helperService: HelpersService,
    ) {
    
  }

  ngOnInit() {
    this.selected = this.sucursalesService.getDefaultSchedule();
  }


  reset() {
    this.selected = {};
    this.isUpdate = false;
    this.errors = {};
  }

  close(){
    $('#sucursales-modal').modal('hide');
  }

  open(sucursal) {
    this.reset();
    if(sucursal !== undefined && sucursal !== null)
    {
      this.selected = sucursal;
      this.isUpdate = true;
    } 
    $('#sucursales-modal').modal('show');
  }

  onKeyup($event) {
    if($event.key == 'Enter') {
      this.accept();
    }
  }

  accept() {
    this.errors = [];

    this.errors = this.sucursalesService.validate(this.selected);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    
    if(this.isUpdate)
      this.update();
    else
      this.create();
    
  }

  create(){
    this.sucursalesService.create(this.selected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.helperService.notification('Sucursal guardada', 'Se ha creado exitosamente la sucursal: ' + this.selected.nombre, 'success');
          this.goToCallback.emit('reload'); // when we emit, we reload the liquidation list
          this.close(); 
        }
      }, error => {
        this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  update() {
    this.sucursalesService.update(this.selected, this.selected.idSucursales)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('Sucursal actualizada', 'Se ha actualizado exitosamente la sucursal: ' + this.selected.nombre, 'success');
          this.goToCallback.emit('reload'); 
          this.close();
        }
      }, error => {
        this.processing = false;

        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/sucursales/sucursales-modal/sucursales-modal.component.ts